'use client';

import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { ResourceTypes } from './resourceTypes';
const wipResourceTypes = [ResourceType.ResourceTypeUnspecified, ResourceType.AwsEfs, ResourceType.AwsFsx, ResourceType.AwsKeyspacesTable, ResourceType.AwsCassandraCluster, ResourceType.GcpCassandraCluster, ResourceType.AzureCassandraCluster, ResourceType.AwsNeptune, ResourceType.AzureFileShare, ResourceType.AzureDisk, ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm, ResourceType.AzureSqlDatabase, ResourceType.AzureSqlManagedInstance, ResourceType.AzureMysql, ResourceType.AzureCosmosdbMongodb, ResourceType.AzureCosmosdbNosql, ResourceType.AzureAksNamespace, ResourceType.GcpGkeNamespace, ResourceType.GcpCloudFirestore, ResourceType.GoogleWorkspaceResource, ResourceType.Microsoft365Resource];
export const useSupportedResourceTypes = t0 => {
  const $ = _c(29);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cloudProviders = t1;
  const {
    isDemo,
    isDev
  } = useEnvironment();
  const {
    AzureSqlDatabaseSupport,
    SapHanaPitrSupport,
    AwsKeyspacesSupport,
    CassandraSupport,
    AzureFilesSupport,
    GoogleWorkspaceSupport,
    m365BackupConsole
  } = useFeatureFlags();
  let t2;
  if ($[2] !== AwsKeyspacesSupport) {
    t2 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[2] = AwsKeyspacesSupport;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== CassandraSupport) {
    t3 = CassandraSupport ? [ResourceType.AwsCassandraCluster, ResourceType.GcpCassandraCluster, ResourceType.AzureCassandraCluster] : [];
    $[4] = CassandraSupport;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== AzureSqlDatabaseSupport) {
    t4 = AzureSqlDatabaseSupport ? [ResourceType.AzureSqlDatabase] : [];
    $[6] = AzureSqlDatabaseSupport;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== SapHanaPitrSupport) {
    t5 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[8] = SapHanaPitrSupport;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== AzureFilesSupport) {
    t6 = AzureFilesSupport ? [ResourceType.AzureFileShare] : [];
    $[10] = AzureFilesSupport;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== GoogleWorkspaceSupport) {
    t7 = GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [];
    $[12] = GoogleWorkspaceSupport;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== m365BackupConsole) {
    t8 = m365BackupConsole ? [ResourceType.Microsoft365Resource] : [];
    $[14] = m365BackupConsole;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ...t2, ...t3, ...t4, ...t5, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t6, ...t7, ...t8];
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const ffResources = t9;
  let t10;
  if ($[24] !== cloudProviders || $[25] !== ffResources || $[26] !== isDemo || $[27] !== isDev) {
    t10 = Object.values(ResourceType).filter(x => x !== ResourceType.ResourceTypeUnspecified && (cloudProviders.length ? cloudProviders.includes(ResourceTypes[x]?.provider) : true) && (isDemo || isDev || !wipResourceTypes.includes(x) || ffResources.includes(x)));
    $[24] = cloudProviders;
    $[25] = ffResources;
    $[26] = isDemo;
    $[27] = isDev;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};